export default function ModeTabs({ modes, active, onChange }) {
  return (
    <div className="flex rounded-lg border border-slate-700 p-1 bg-slate-900/80 mb-6">
      {modes.map((mode) => (
        <button
          key={mode.id}
          type="button"
          onClick={() => onChange(mode.id)}
          className={`flex-1 rounded-md px-3 py-2 text-sm font-medium transition-colors ${
            active === mode.id
              ? 'bg-emerald-600 text-white shadow-sm'
              : 'text-slate-400 hover:text-slate-200'
          }`}
        >
          {mode.label}
        </button>
      ))}
    </div>
  );
}
